import { SVGProps, Ref, forwardRef } from 'react';

export const KeyOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 5c1.5 0 3 .75 3 3s-1.5 3-3 3-3-.75-3-3 1.5-3 3-3m0 1.8c-.483 0-.772.124-.91.24-.07.058-.24.22-.28.723L6.8 8c0 .692.21.894.29.96.138.116.427.24.91.24s.772-.124.91-.24c.08-.066.29-.268.29-.96s-.21-.894-.29-.96c-.138-.116-.427-.24-.91-.24"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 1c4 0 8 2 8 8 0 .782-.07 1.495-.196 2.146L18 12.342V14h1.658l.342.342V16h1.657L23 17.343V21.5L17.343 23l-6.206-6.207C10.44 16.934 9.72 17 9 17c-4 0-8-2-8-8s4-8 8-8m0 1.8c-1.733 0-3.272.437-4.348 1.333C3.635 4.98 2.8 6.433 2.8 9s.835 4.02 1.852 4.867C5.728 14.763 7.267 15.2 9 15.2c.612 0 1.211-.056 1.78-.17l.947-.193 6.155 6.157 3.318-.88v-2.026l-.288-.288H18.2v-2h-2v-2.713l-1.346-1.346.183-.94A9.4 9.4 0 0 0 15.2 9c0-2.567-.835-4.02-1.852-4.867C12.272 3.237 10.733 2.8 9 2.8"
            fill="currentColor"
        />
    </svg>
));
KeyOutlinedSize24Glyph.displayName = 'KeyOutlinedSize24Glyph';
